import { render } from "./photonPersistentDisk.vue?vue&type=template&id=030549cd"
import script from "./photonPersistentDisk.vue?vue&type=script&lang=js"
export * from "./photonPersistentDisk.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__